import { actionCopyFr } from "./actionCopy";

export const analyticsCopyFr = {
    navTitle: "Analyses",
    navDescription: "Analysez les données de vos patients",
    events: "Événements",
    outcomes: "Résultats",
    rawData: "Données brutes",
    searchPatientsPlaceholder: "Rechercher des patients...",
    searchPatientsAria: "Rechercher des patients par nom ou autres champs",
    clearPatientSearchAria: "Effacer la recherche de patients",
    editWithAiPlaceholder: "Modifier avec l'IA",
    editWithAiAria: "Modifier avec l'IA",
    stopAiEditAria: "Arrêter l'IA",
    downloadCsv: "Télécharger le CSV",
    preparingCsv: "Préparation du CSV...",
    downloadSas: "Exporter pour SAS",
    preparingSas: "Préparation du SAS...",
    sasExportHelp:
        "Téléchargez vos données d'analyse pour SAS. L'étude et les dates sont facultatives : laissez-les vides pour exporter tout ce que vous pouvez voir. Les colonnes utilisent les OID des variables et les réponses codées, ou le texte de la question lorsqu'un formulaire n'a pas encore d'OID.",
    sasStudy: "Étude",
    sasFrom: "Du",
    sasTo: "Au",
    sasExport: "Exporter",
    sasDateOrder: "La date de début doit être antérieure ou égale à la date de fin.",
    sasFailed: "L'export SAS a échoué. Réessayez.",
    sasForbidden: "Vous n'avez pas l'autorisation d'exporter cette étude.",
    sasUnmapped: "Aucune question à exporter pour cette sélection.",
    sasEmpty: "Aucune saisie pour cette étude et cette période.",
    sasRetry: "Réessayer",
    sasAllStudies: "Toutes les études",
    sasAnyDate: "Toute date",
    sasClearDate: (label: string) => `Effacer la date « ${label.toLowerCase()} »`,
    sasProgress: (loaded: number, total: number) => `Chargement des journaux : ${loaded} sur ${total}`,
    columns: actionCopyFr.columns,
    columnVisibilityDiffers: "La visibilité des colonnes diffère de la valeur par défaut",
    filter: actionCopyFr.filter,
    addFilter: "Ajouter un filtre",
    filtersFor: (name: string) => `Filtres pour « ${name} »`,
    activeFilters: (count: number) => `${count} filtre${count === 1 ? "" : "s"} actif${count === 1 ? "" : "s"}`,
    edit: actionCopyFr.edit,
    done: actionCopyFr.done,
    shared: "Partagé",
    noData: "Aucune donnée",
    noScoresForFilter: "Aucun score pour cette combinaison de filtres",
    failedToLoadEvents: "Échec du chargement des événements",
    noEvents: "Aucun événement",
    patients: "Patients",
    gender: "Sexe",
    age: "Âge",
    area: "Zone",
    diaryId: "ID du journal",
    patient: "Patient",
    date: "Date",
    optionsFor: (name: string) => `Options pour ${name}`,
    shiftLeft: "Décaler vers la gauche",
    pieChart: "Graphique circulaire",
    donutChart: "Graphique en anneau",
    barChart: "Graphique à barres",
    lineChart: "Graphique linéaire",
    sparkCharts: "Graphiques sparkline",
    statsTable: "Tableau statistique",
    statsTableSpark: "Tableau statistique + sparkline",
    table: "Tableau",
    stats: "Statistiques",
    timepointTable: "Tableau par échéance",
    histogram: "Histogramme",
    outliers: "Valeurs aberrantes",
    changeFromBaseline: "Variation par rapport à l'inclusion",
    cumulativeEnrolment: "Inclusions cumulées",
    engagementRate: "Complétude parmi ceux qui ont commencé",
    followUpCompletion: "Complétude du suivi",
    engagementHint:
        "Part des journaux commencés qui ont terminé chaque suivi. La valeur initiale est le premier questionnaire, elle doit donc se situer près du taux de démarrage du journal. Une fin tardive compte quand même comme terminée. Les journaux jamais commencés sont exclus, de même que les fenêtres encore ouvertes.",
    engagementPercentCompleted: "Pourcentage terminé",
    engagementRateHint:
        "Parmi les patients qui ont commencé le questionnaire : terminé dans le mois, seulement quelques questions dans le mois, ou non terminé dans le mois. Les patients qui n'ont jamais commencé ne sont pas inclus.",
    engagementComplete: "Dans les temps",
    engagementPartial: "Partiel dans le mois",
    engagementNotStarted: "Non commencé",
    engagementNotWithin: "Pas dans le mois",
    engagementDue: "À faire",
    engagementStarted: "Commencé",
    engagementOfPatientsDue: "Pourcentage de patients avec un suivi à faire",
    engagementOfPatientsStarted: "Pourcentage de patients qui ont commencé",
    engagementOfDue: (completed: number, due: number) => `${completed} sur ${due} à faire`,
    engagementLate: "En retard",
    engagementMissed: "Manqué",
    engagementCompletion: "Complétude",
    engagementAllPatients: "Tous les patients",
    engagementPatientsDue: (n: number) => `${n} à faire`,
    engagementHeatmapSplitHint:
        "Choisissez « Split by » dans les paramètres du graphique pour comparer des sites, des étiquettes ou des cliniciens.",
    engagementDotSize: "La taille du point indique combien de patients avaient un suivi à faire.",
    engagementDispositionHint:
        "Chaque patient compte une fois par fenêtre clinique. Les suivis ouverts sont exclus tant qu'ils ne sont pas terminés ou que la fenêtre autorisée n'est pas close.",
    engagementTimingHint:
        "Jours entre l'envoi et l'heure prévue. Le point est l'écart médian et la barre correspond aux 50 % centraux.",
    engagementTimingRangeHint:
        "Zéro est l'heure prévue. Un nombre positif indique les jours de retard et un nombre négatif les jours d'avance. Dans les temps signifie dans la fenêtre autorisée de part et d'autre de cette heure : l'intervalle jusqu'au suivi suivant, de 1 jour jusqu'à 21 jours.",
    engagementOnTimeCount: (onTime: number, completed: number) => `${onTime} sur ${completed} dans les temps`,
    engagementTimingWindowColumn: "Fenêtre autorisée",
    engagementDayWindow: (min: number, max: number) =>
        min === max ? `Fenêtre de ${min} jours` : `Fenêtre de ${min} à ${max} jours`,
    engagementTimingWindowSummary: (min: number, max: number) =>
        min === max ? `Dans une fenêtre de ${min} jours` : `Dans une fenêtre de ${min} à ${max} jours`,
    engagementWithinWindowCount: (onTime: number, completed: number, min: number, max: number) =>
        min === max
            ? `${onTime} sur ${completed} dans une fenêtre de ${min} jours`
            : `${onTime} sur ${completed} dans une fenêtre de ${min} à ${max} jours`,
    engagementOutsideDayWindow: (n: number, min: number, max: number) =>
        min === max ? `${n} hors de la fenêtre de ${min} jours` : `${n} hors de la fenêtre de ${min} à ${max} jours`,
    engagementOutsideWindow: (n: number, window?: string) =>
        window ? `${n} hors de la fenêtre (${window})` : `${n} hors de la fenêtre`,
    engagementWindowDays: (min: number, max: number) =>
        min === max ? `±${min} ${min === 1 ? "jour" : "jours"}` : `±${min} à ${max} jours`,
    engagementOutsideWindowColumn: "Hors de la fenêtre",
    engagementGapDays: (days: number) => {
        const rounded = Math.round(days * 10) / 10;
        const unit = Math.abs(rounded) === 1 ? "jour" : "jours";
        if (rounded === 0) return `0 ${unit}`;
        return `${rounded > 0 ? "+" : ""}${rounded} ${unit}`;
    },
    engagementTimingAxisDays: (days: number) => {
        if (days === 0) return "0";
        const unit = Math.abs(days) === 1 ? "jour" : "jours";
        return `${days > 0 ? "+" : ""}${days} ${unit}`;
    },
    engagementTimingEmpty: "Aucun suivi programmé et terminé n'a de données de temps",
    engagementEarlier: "En avance",
    engagementScheduled: "Programmé",
    engagementLater: "En retard",
    engagementMedian: "Médiane",
    engagementCompleted: "Terminé",
    engagementMiddle50: "50 % centraux",
    engagementCompletedCount: (n: number) => `${n} terminés`,
    engagementMetrics: "Indicateurs de participation",
    engagementMetricsHint:
        "La complétude des saisies et des journaux utilise les questionnaires des patients sur les journaux déjà commencés. Le décompte des journaux terminés porte sur ces journaux commencés. Les formulaires du clinicien sont exclus.",
    engagementMetric: "Indicateur",
    engagementRateColumn: "Taux",
    engagementCount: "Nombre",
    engagementOnTimeRate: "Taux dans les temps",
    engagementDiaryStartRate: "Taux de démarrage du journal",
    engagementEntryCompletionRate: "Taux de complétude des saisies",
    engagementDiaryCompletionRate: "Taux de complétude du journal",
    engagementDiariesStarted: (completed: number, due: number) => `${completed} sur ${due} journaux commencés`,
    engagementEntriesCompleted: (completed: number, due: number) => `${completed} sur ${due} saisies terminées`,
    engagementDiariesCompleted: (completed: number, due: number) => `${completed} sur ${due} journaux terminés`,
    engagementWindows: {
        baseline: "Valeur initiale",
        w6: "Jusqu'à 6 semaines",
        m3: "De 6 semaines à 3 mois",
        m6: "De 3 à 6 mois",
        m12: "De 6 à 12 mois",
        m12plus: "Plus de 12 mois",
    } as Record<string, string>,
    engagementAllCompleted: "Tous terminés",
    engagementSomeCompleted: "Quelques-uns terminés",
    engagementNoneStarted: "Aucun suivi n'a encore été commencé",
    engagementOnTime: "Dans les temps",
    engagementUnderMonth: "Moins d'1 mois de retard",
    engagementOverMonth: "Plus d'1 mois de retard",
    engagementEmpty: "Aucun suivi programmé n'est encore à faire",
    engagementPatient: "Patient",
    engagementClinician: "Clinicien",
    engagementCohort: "Cohorte",
    engagementByLabel: "Étiquette du journal",
    engagementByClinician: "Clinicien",
    engagementByTracker: "Questionnaire",
    engagementFollowUp: "Suivi",
    engagementFollowUpGrain: "Calendrier",
    engagementFollowUpAbsolute: "Absolu",
    engagementFollowUpGrouped: "Groupé",
    engagementFollowUpDaily: "Quotidien",
    engagementFollowUpWeekly: "Hebdomadaire",
    engagementFollowUpMonthly: "Mensuel",
    engagementFollowUpQuarterly: "Trimestriel",
    engagementFollowUpYearly: "Annuel",
    engagementFollowUpDays: "Jours",
    engagementFollowUpWeeks: "Semaines",
    engagementFollowUpMonths: "Mois",
    engagementFollowUpYears: "Années",
    engagementFollowUpAbsoluteHint: "Chaque suivi reste un point à part, dans l'ordre du calendrier.",
    engagementFollowUpGroupedHint: "Groupé affiche Mois 0, Mois 1, Mois 2. Le Mois 0 correspond aux 30 premiers jours.",
    engagementFollowUpStep: (grain: "day" | "week" | "month" | "quarter" | "year", index: number) => {
        const label =
            grain === "day"
                ? "Jour"
                : grain === "week"
                  ? "Semaine"
                  : grain === "month"
                    ? "Mois"
                    : grain === "quarter"
                      ? "Trimestre"
                      : "Année";
        return `${label} ${index}`;
    },
    engagementFollowUpGrainHint: (grain: "day" | "week" | "month" | "quarter" | "year") => {
        if (grain === "day")
            return "Quotidien affiche Jour 0, Jour 1, Jour 2. Le Jour 0 est le jour de l'intervention.";
        if (grain === "week")
            return "Hebdomadaire affiche Semaine 0, Semaine 1, Semaine 2. La Semaine 0 correspond aux 7 premiers jours.";
        if (grain === "quarter")
            return "Trimestriel affiche Trimestre 0, Trimestre 1, Trimestre 2. Le Trimestre 0 correspond aux 90 premiers jours.";
        if (grain === "year") return "Annuel affiche Année 0, Année 1, Année 2. L'Année 0 est la première année.";
        return "Mensuel affiche Mois 0, Mois 1, Mois 2. Le Mois 0 correspond aux 30 premiers jours.";
    },
    engagementGroupAria: "Détail de la participation",
    engagementOf: (completed: number, due: number) => `${completed} sur ${due}`,
    unlabelled: "Sans étiquette",
    unassigned: "Non attribué",
    timepoint: "Échéance",
    ageBracket: "Tranche d'âge",
    label: "Étiquette du journal",
    sex: "Sexe",
    anatomicArea: "Zone anatomique",
    event: "Événement",
    form: "Formulaire",
    averageAge: "Âge moyen",
    patientCountsByAgeBracket: "Nombre de patients par tranche d'âge",
    ageDistribution: "Répartition par âge",
    chartOfGender: (chart: string) => `${chart} par sexe`,
    patientCountsByGender: "Nombre de patients par sexe",
    totalPatients: "Total des patients",
    meanField: (field: string) => `Moyenne : ${field}`,
    formStats: (form: string) => `Statistiques : ${form}`,
    tableOf: (dataset: string) => `Tableau : ${dataset}`,
    sparkChartsOf: (form: string) => `Graphiques sparkline : ${form}`,
    statsTableOf: (form: string) => `Tableau statistique : ${form}`,
    statsTableByTimepoint: (form: string) => `Tableau statistique par échéance : ${form}`,
    statsTableSparkOf: (form: string) => `Tableau statistique + sparkline : ${form}`,
    statsTableSparkByTimepoint: (form: string) => `Tableau statistique + sparkline par échéance : ${form}`,
    lineChartOverTime: (form: string) => `Graphique linéaire de ${form} dans le temps`,
    byTimepoint: (form: string) => `${form} par échéance`,
    histogramOf: (subject: string) => `Histogramme : ${subject}`,
    outliersOf: (subject: string) => `Valeurs aberrantes : ${subject}`,
    ageOutliers: "Valeurs aberrantes de l'âge",
    outlierChart: {
        allPatients: "Tous les patients",
        noOutliers: "Aucune valeur au-delà des limites.",
        rule: "Les points à plus de 1,5 × IQR de la boîte sont signalés. La boîte couvre la moitié centrale des réponses et la ligne indique la médiane.",
        flagged: (count: number) => `${count} signalée(s)`,
        patient: "Patient",
        timepoint: "Temps",
        value: "Valeur",
        range: "Plage attendue",
        more: (count: number) => `et ${count} de plus`,
        between: (low: string, high: string) => `${low} à ${high}`,
        organisation: "Organisation",
        createdBy: "Créé par",
        startDate: "Début du journal",
        private: "Privé",
        ageYears: (count: number) => `${count} ans`,
        responses: "Réponses",
        mean: "Moyenne",
        flaggedLabel: "Signalées",
        rangeJoin: "à",
        tooFew: "Trop peu de réponses pour signaler des valeurs aberrantes",
    },
    previousTreatments: (form: string) => `Traitements précédents · ${form}`,
    patientCountsBy: (group: string) => `Nombre de patients par ${group}`,
    barChartOfBy: (subject: string, group: string) => `Graphique à barres : ${subject} par ${group}`,
    chartOf: (chart: string, subject: string) => `${chart} : ${subject}`,
    chartOfBy: (chart: string, dataset: string, field: string) => `${chart} : ${dataset} par ${field}`,
    bySuffix: (title: string, split: string) => `${title} par ${split}`,
    changeFromBaselineSubject: (subject: string) => `Variation par rapport à l'inclusion · ${subject}`,
    lsmeanChange: (subject: string) => `Variation de la moyenne des moindres carrés · ${subject}`,
    percentOfMax: (subject: string) => `% du maximum · ${subject}`,
    percentChangeFromBaseline: (subject: string) => `% de variation par rapport à l'inclusion · ${subject}`,
    score: "Score",
    shiftRight: "Décaler vers la droite",
    rename: actionCopyFr.rename,
    duplicate: actionCopyFr.duplicate,
    share: actionCopyFr.share,
    delete: actionCopyFr.delete,
    cancel: actionCopyFr.cancel,
    addView: "Ajouter une vue",
    addViewDescription: "Choisissez d'abord un tableau de bord de graphiques ou une feuille de données brutes.",
    addViewStepOf: (step: number, total: number) => `Étape ${step} sur ${total}`,
    addViewStepTypeTitle: "Quel type de vue ?",
    addViewStepTypeDescription:
        "Choisissez un tableau de bord de graphiques ou une feuille de données brutes. Vous pourrez ensuite copier des paramètres et solliciter l'IA.",
    addViewStepSetupTitle: "Copier des paramètres ou solliciter l'IA",
    addViewStepSetupDescription:
        "Facultatif. Copiez les filtres d'un autre onglet, décrivez ce que vous souhaitez, ou les deux.",
    addViewBack: "Retour",
    addViewAiLabel: "Demander à l'IA",
    addViewAiPlaceholderCharts: "Facultatif : décrivez les graphiques souhaités, p. ex. WOMAC dans le temps par âge",
    addViewAiPlaceholderData:
        "Facultatif : décrivez les filtres, p. ex. journaux du genou de patients de plus de 60 ans",
    copySettingsFrom: "Copier les paramètres de",
    none: actionCopyFr.none,
    charts: "Graphiques",
    data: "Données",
    chartsDescription: "Widgets, tendances et statistiques récapitulatives",
    dataDescription: "Feuille de calcul des lignes patients et des scores",
    createChartsView: "Créer une vue de graphiques",
    createDataView: "Créer une vue de données",
    refreshAria: "Actualiser les données d'analyse",
    addWidget: "Ajouter un widget",
    addWidgetFor: (name: string) =>
        `Choisissez un formulaire, un champ facultatif et le mode d'affichage pour « ${name} ».`,
    noWidgetsOnTab: "Aucun widget sur cet onglet pour le moment.",
    useAddWidgetToChart: (label: string) =>
        `Utilisez « Ajouter un widget » ci-dessus pour représenter graphiquement de vraies données ${label}.`,
    diaryFallback: "journal",
    failedToLoadAnalytics: "Échec du chargement des données d'analyse",
    failedToLoadData: "Échec du chargement des données",
    failedToLoadPatientData: "Échec du chargement des données patients. Actualisez pour réessayer.",
    loadingPatients: "Chargement des patients...",
    loadingAnalytics: (label: string) => `Chargement des données ${label}...`,
    analyticsFallback: "d'analyse",
    fieldFallback: "Champ",
    /** Under the total in the middle of a form donut. */
    donutResponses: "réponses",
    noWidgetsYet: "Aucun widget pour le moment. Ajoutez-en un depuis la palette ou demandez à l'assistant IA.",
    noWidgetsConfigured: "Aucun widget configuré pour cette vue.",
    clearFilters: "Effacer les filtres",
    deleteViewTitle: "Supprimer la vue ?",
    deleteViewDescription: (name: string) =>
        `Cela supprimera définitivement « ${name} » et ses widgets. Cette action est irréversible.`,
    showingRangeOf: (start: string, end: string, total: string, noun: string) =>
        `Affichage de ${start} à ${end} sur ${total} ${noun}`,
    rowSingular: "ligne",
    rowPlural: "lignes",
    diarySingular: "journal",
    diaryPlural: "journaux",
    noPatientsMatch: (query: string) => `Aucun patient ne correspond à « ${query} »`,
    noPatientsMatchFilters: "Aucun patient ne correspond aux filtres actuels",
    searchColumnsPlaceholder: "Rechercher des colonnes...",
    searchColumnsAria: "Rechercher des colonnes",
    visibleColumns: "Colonnes visibles",
    showAll: "Tout afficher",
    hideAll: "Tout masquer",
    eventsCount: "événements",
    acrossDiaries: (count: number) => `Sur ${count} ${count === 1 ? "journal" : "journaux"}`,
    eventPrefix: (label: string) => `Événement · ${label}`,
    chartSettings: "Paramètres du graphique",
    severalDataTabsHint:
        "Vous avez déjà plusieurs onglets de données - envisagez d'ajuster les filtres ou les colonnes d'un onglet existant.",
    chartN: (n: number) => `Graphique ${n}`,
    dataN: (n: number) => `Données ${n}`,
    showingColumnsOf: (visible: string, total: string) => `Affichage de ${visible} colonnes sur ${total}`,
    noColumnsMatch: (query: string) => `Aucune colonne ne correspond à « ${query} »`,
    filterCategories: {
        mine: "Mon rôle",
        demographic: "Données démographiques",
        label: "Étiquette du journal",
        org: "Organisation",
        form: "Formulaire",
        event: "Événement",
        status: "Statut du journal",
    },
    filterAnnotations: {
        mine: "Journaux dans lesquels vous avez l'un de ces rôles.",
        label: "Journaux avec l'une de ces étiquettes.",
        org: "Journaux dans l'une de ces organisations.",
        status: "Journaux avec l'un de ces statuts.",
    },
    filteredBy: "Filtré par",
    sexValues: { Female: "Femme", Male: "Homme", Other: "Inconnu" },
    rawCellExplanations: {
        genderInferred:
            "Le sexe est déduit de la civilité figurant dans le nom du patient (p. ex. M., Mme). Modifiez la colonne Nom pour le changer.",
        genderPrivate:
            "Le sexe est une caractéristique de cohorte déduite de la civilité (p. ex. M., Mme). Le nom reste privé pour votre niveau d'accès.",
        patientNamePrivate: "Le nom du patient est privé pour votre niveau d'accès.",
        patientNameHidden: "Le nom du patient est masqué sans accès aux données identifiables.",
        dobPrivate: "La date de naissance est privée pour votre niveau d'accès.",
        ageEditable:
            "Âge à la date de début du journal, calculé à partir de la date de naissance - et non l'âge actuel du patient. Modifiez la date de naissance pour le changer.",
        agePrivate:
            "Âge à la date de début du journal, calculé à partir de la date de naissance - et non l'âge actuel du patient. La date de naissance reste privée pour votre niveau d'accès.",
        ageReadonly:
            "Âge à la date de début du journal, calculé à partir de la date de naissance - et non l'âge actuel du patient.",
        sideDerived:
            "Le côté auquel se rapportent les questionnaires de cette ligne. Choisissez « Les deux » si les deux côtés sont concernés.",
        noQuestionnaireSide: "Aucun questionnaire sur cette ligne pour lequel définir un côté.",
        noEditableEvent: "Aucun événement modifiable sur ce journal.",
        unsupportedEventValue:
            "Cette valeur n'est pas prise en charge par le formulaire de modification de l'événement.",
        noEventDate: "Aucune date d'événement à modifier sur ce journal.",
        noEditableArea: "Aucun événement modifiable ne fournit cette zone.",
        shockwaveProcedure: "Les ondes de choc constituent le type d'intervention, et non un détail modifiable.",
        noEditableProcedure: "Aucun événement modifiable ne fournit cette intervention.",
        ageDerived:
            "Âge à la date de début du journal, calculé à partir de la date de naissance. Ce n'est pas l'âge actuel du patient.",
        durationDerived: "Calculée entre la date de début du journal et aujourd'hui.",
        ageAtEventDerived: (event: string) =>
            `Calculé à partir de la date de naissance et de la date la plus ancienne de ${event}.`,
        noTracker: "Aucun suivi à cette échéance pour ce journal.",
        noSideTracker: (side: string) => `Aucun suivi (${side}) à cette échéance pour ce journal.`,
        notOnSchedule: "Cette échéance ne figure pas dans le calendrier de ce suivi.",
        editFromDiary: "Modifiez cette réponse depuis le journal du patient.",
        notOnSideSchedule: (side: string) => `Cette échéance ne figure pas dans le calendrier du suivi (${side}).`,
        multipleEventRows: (event: string) =>
            `Cet événement (${event}) comporte plusieurs lignes de détails. Modifiez-le depuis le journal du patient pour ne pas remplacer les autres détails.`,
        multipleEvents: (event: string) =>
            `Plusieurs événements (${event}) contribuent à cette cellule. Modifiez-les depuis le journal du patient.`,
        multipleDates: (event: string) =>
            `Plusieurs dates (${event}) contribuent à cette cellule. Modifiez-les depuis le journal du patient.`,
        editDobHelper: "L'âge au début du journal est calculé à partir de cette date de naissance.",
        editEventDateHelper: (event: string) => `Modifier la date (${event}).`,
    },
    eventDatasetLabels: {
        injection: "Injections",
        surgery: "Opérations",
        shockwave: "Ondes de choc",
        product: "Produits",
        education: "Consultations",
        medication: "Médicaments",
    } as Record<string, string>,
    rawSideValues: { left: "gauche", right: "droit", both: "les deux", middle: "milieu" } as Record<string, string>,
    showDetailsAria: "Afficher les détails",
    widgetTypes: {
        stat: "Carte statistique",
        bar: "Barres",
        histogram: "Histogramme",
        outliers: "Valeurs aberrantes",
        donut: "Anneau",
        pie: "Secteurs",
        line: "Ligne/aire",
        spark: "Graphiques sparkline",
        statsTable: "Tableau statistique",
        statsTableSpark: "Tableau statistique + sparkline",
        timepoints: "Tableau par échéance",
        table: "Tableau",
        enrolment: "Inclusions cumulées",
        engagement: "Complétude du suivi",
        engagementTable: "Tableau des suivis",
        engagementRate: "Parmi ceux qui ont commencé",
        engagementDisposition: "Situation du patient",
        engagementTiming: "Calendrier par rapport au plan",
        engagementRetention: "Courbe de rétention",
        engagementKpi: "Chiffres principaux",
        engagementHeatmap: "Carte de chaleur par répartition",
        engagementDots: "Nuage de points",
    },
    valueTransforms: {
        absolute: "Absolu",
        changeFromBaseline: "Variation par rapport à l'inclusion",
        lsmeanChange: "Variation de la moyenne des moindres carrés",
        percentOfMax: "% du maximum",
        percentChangeFromBaseline: "% de variation par rapport à l'inclusion",
    },
    summaryTable: {
        unknownForm: "Formulaire inconnu",
        noEntries: "Aucune saisie",
        metric: "Indicateur",
        distribution: "Distribution",
        boxPlot: "Boîte à moustaches",
        mean: "Moyenne",
        median: "Médiane",
        mode: "Mode",
        sd: "É.-T.",
        ci: "IC à 95 %",
        frequency: "Fréquence",
        value: "Valeur",
        count: "Effectif",
        percent: "%",
        indicator: "Indicateur",
        proportion: "Proportion",
        entries: "Saisies",
        yes: "Oui",
        no: "Non",
    },
    rawColumnGroups: {
        Patient: "PATIENT",
        INJECTION: "INJECTION",
        SURGERY: "OPÉRATION",
        SHOCKWAVE: "ONDES DE CHOC",
        PRODUCT: "PRODUIT",
        CONSULTATION: "CONSULTATION",
    } as Record<string, string>,
    rawFieldLabels: {
        Date: "Date",
        Substance: "Substance",
        Area: "Zone",
        Site: "Site",
        Side: "Côté",
        Dose: "Dose",
        Type: "Type",
        Procedure: "Intervention",
        Product: "Produit",
        Topic: "Sujet",
        "Provided by": "Fourni par",
        "Delivered by": "Réalisé par",
        "Referring clinician": "Médecin adresseur",
        "Injecting clinician": "Clinicien réalisant l'injection",
        "Operating clinician": "Clinicien opérateur",
        "Shockwaving clinician": "Clinicien réalisant les ondes de choc",
    } as Record<string, string>,
    rawColumnLabels: {
        diary_id: "ID du journal",
        patient_name: "Nom",
        date_of_birth: "Date de naissance",
        age: "Âge au début",
        gender: "Sexe",
        organisation: "Organisation",
        side: "Côté",
        area: "Zone",
        procedure: "Intervention",
    } as Record<string, string>,
    scoreUnavailable: "Indisponible",
    scoreAdd: "Ajouter un score",
    scoreNotDueYet: "Pas encore à faire",
    scoreLate: "En retard",
    scoreClickToAddTooltip: "Cliquez sur la cellule pour ajouter un score",
    scoreLateTooltip: "Cette échéance est en retard. Cliquez sur la cellule pour ajouter un score.",
    scoreNotDueTooltip: "Cette échéance n'est pas encore à faire. Cliquez sur la cellule pour ajouter un score.",
    scoreNoTrackerTooltip: "Aucun suivi à cette échéance pour ce journal.",
    editScore: "Modifier le score",
    clearScore: "Effacer",
    decreaseScoreAria: "Diminuer le score",
    increaseScoreAria: "Augmenter le score",
    scoreRange: (min: number, max: number) => `Plage ${min} - ${max}`,
    scoreMin: (min: number) => `Min ${min}`,
    scoreMax: (max: number) => `Max ${max}`,
    confidential: "Confidentiel",
    confidentialAria: "Données patient confidentielles. Afficher pourquoi.",
    thisTimepoint: "Cette échéance",
    dueDate: (date: string) => `À faire le ${date}`,
    enteredDate: (date: string) => `Saisi le ${date}`,
    entryNotEnteredYet: "Pas encore saisi",
    timepointHasRecordedScore: (point: string) => `${point} a un score enregistré.`,
    timepointDates: (point: string, dates: string) => `${point} : ${dates}.`,
    timepointNoTracker: (point: string) =>
        `${point} n'a pas de suivi sur ce journal, un score ne peut donc pas être ajouté.`,
    clickToAddScore: "Cliquez pour ajouter un score.",
};
